import API from 'app/utils/apiClient';

import { PAYMENT_VENDORS, PAYMENT_TYPES } from 'app/utils/constants';
import { toParams } from 'app/utils/url';

const getPaymentItems = (
  vendor = PAYMENT_VENDORS.STANDARD,
  type = PAYMENT_TYPES.COIN
) => {
  const params = toParams({
    vendor,
    type,
  });
  return API.get(`/store/payment-items/?${params}`);
};

const verifyPayment = (impUid, item) =>
  API.post('/store/imp-payment-verify/', { impUid, item });

const consumeCouponByCode = (code) =>
  API.post(`/store/coupon-codes/${code}/consume/`);

const consumeCouponById = (id) => API.post(`/store/coupons/${id}/consume/`);

const getPurchaseInfo = (storyId, episodeId) =>
  API.get(`/stories/${storyId}/episodes/${episodeId}/purchase-info/`);

const fetchPromotion = (promotionId) =>
  API.get(`/store/promotions/${promotionId}`);

const postPromotion = (promotionId) =>
  API.post(`/store/promotions/${promotionId}/histories/`);

const postUniversalBalloon = (balloon, description, transactionId) =>
  API.post('/store/universal-use-balloon/', {
    balloon,
    description,
    transactionId,
  });

export default {
  getPaymentItems,
  verifyPayment,
  consumeCouponByCode,
  consumeCouponById,
  getPurchaseInfo,
  fetchPromotion,
  postPromotion,
  postUniversalBalloon,
};



// WEBPACK FOOTER //
// ./src/app/apis/store.js